export const ProjectType = {
  INTERNAL: 'Internal',
  CLIENT: 'Client',
  GROUP: 'Group',
  OVERHEAD: 'Overhead',
}
